import PermissionGate from "~/components/PermissionGate";
import CustomeButton from "~/components/Button";
import DirectorAttachmentTable from "./DirectorAttachmentTable";
import FileUploadModal from "~/components/Processes/conversations/FileUploadModal";
import { mergeCategories } from "~/Pages/Requests/components/new-request-modal/utils";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import Notification from "~/components/entities/notification/Notification";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";
import useDirectorAttachments from "./useDirectorAttachments";
import BlobFilter from "~/components/BlobFilter";
import FilterChip from "~/components/FilterChip";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes";
import { useParams } from "react-router-dom";
import React from "react";
import FolderListSection from "~/components/folder-list-section/FolderListSection";
import ProfileAttachmentsBreadcrumb from "~/components/profile-attachments-breadcrumb/ProfileAttachmentsBreadcrumb";

const DirectorProfileAttachments = ({ directorData, entityId }) => {
  const { directorId } = useParams();
  const [isAuditSidebarVisible, setAuditSidebarVisible] = React.useState(false);

  const {
    onPageChange,
    loading,
    isDataAvailable,
    filesData,
    rows,
    first,
    handleDeleteDocument,
    openDialog,
    setOpenDialog,
    isFileUploaded,
    attachmentConfirmModal,
    setAttachmentConfirmModal,
    successMessage,
    setSuccessMessage,
    temporaryMessage,
    setTemporaryMessage,
    restoreMessage,
    setRstoreMessage,
    isAttachmentLoader,
    uploadFileHandler,
    handleRestoreAttachment,
    handleConfirmDelete,
    fileSupported,
    getNameForFile,
    role,
    selectedItems,
    filterData,
    setFilterData,
    removeFnRef,
    handleRemoveFilter,
    handleFilterChange,
    filterLoading,
    onSortOrderChange,
    onFilterApply,
    allData,
    filterPageChange,
    currentPage,
    fetchDirectorAttachments,
    categoryFolders,
    selectedCategory,
    setSelectedCategory,
    handleCategoryFolderClick,
    displayFiles,
  } = useDirectorAttachments({ directorData });

  const auditLabels = () => {
    return {
      create: "File Uploaded",
      update: "File Updated",
      delete: "File(s) Deleted",
    };
  };
  return (
    <div className="shareholder__attachments">
      <div className="flex justify-content-between mb-5">
        <div className="flex-1">
          <ProfileAttachmentsBreadcrumb
            selectedCategory={selectedCategory}
            onBackToCategories={() => setSelectedCategory(null)}
            onRefetch={fetchDirectorAttachments}
          />
        </div>
        <div className="inline-flex gap-2">
          <PermissionGate
            resource="director"
            action="modify"
            resourceAttr={{ entity_id: entityId }}
          >
            <CustomeButton
              label="View History"
              icon="pi pi-history"
              iconPos="right"
              className="edit-button"
              onClick={() => setAuditSidebarVisible(true)}
            />
          </PermissionGate>
          <BlobFilter
            onApply={({ value, group }) => {
              setFilterData(value);
            }}
            onRemove={(fn) => (removeFnRef.current = fn)}
            onFilterChange={({ value, grouped }) => {
              handleFilterChange(grouped);
            }}
            showEntity={false}
            showServiceLine={false}
            showYears={false}
            serviceLine={"Entities +"}
            disabled={!isDataAvailable}
          />
          <PermissionGate
            resource="director"
            action="modify"
            resourceAttr={{ entity_id: entityId }}
          >
            <CustomeButton
              label="Upload File"
              icon="pi pi-upload"
              iconPos="right"
              className="upload-file-button"
              onClick={() => setOpenDialog(true)}
            />
          </PermissionGate>
        </div>
      </div>
      <FilterChip
        filterData={filterData}
        removeFilter={(id) => {
          handleRemoveFilter(id);
        }}
      />
      <Notification
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
      />
      <TemporaryNotification
        onUndo={handleRestoreAttachment}
        successMsg={temporaryMessage}
        setMessages={setTemporaryMessage}
      />
      <div className="mt-4">
        {!selectedCategory && !selectedItems.length ? (
          <FolderListSection
            folders={categoryFolders}
            loading={loading}
            onFolderClick={handleCategoryFolderClick}
            showEmptyState={true}
            emptyMessage="No files here yet"
          />
        ) : (
          <>
            <DirectorAttachmentTable
              onPageChange={
                selectedItems.length
                  ? (e) => {
                      filterPageChange(e.page + 1);
                    }
                  : onPageChange
              }
              loading={selectedItems.length ? filterLoading : loading}
              isDataAvailable={
                selectedItems.length
                  ? allData.length
                  : selectedCategory
                    ? displayFiles.length
                    : isDataAvailable
              }
              files={
                selectedItems.length
                  ? allData
                  : selectedCategory
                    ? displayFiles
                    : filesData
              }
              rows={rows}
              first={selectedItems.length ? currentPage - 1 : first}
              handleAttachmentDelete={handleDeleteDocument}
              totalRecords={
                selectedItems.length
                  ? allData.length
                  : selectedCategory
                    ? displayFiles.length
                    : filesData.length
              }
              setOpenDialog={setOpenDialog}
              onSortOrderChange={
                selectedItems?.length ? onSortOrderChange : undefined
              }
              isFilterApplied={selectedItems.length}
              onRefetch={
                selectedItems?.length ? onFilterApply : fetchDirectorAttachments
              }
              entityId={entityId}
            />
          </>
        )}
      </div>
      <FileUploadModal
        entitydata={directorData?.entityData}
        showModal={openDialog}
        fileSupported={fileSupported}
        hideUploadModal={() => setOpenDialog(false)}
        setUploadedFile={uploadFileHandler}
        getService={getNameForFile}
        placeholder={"Choose a file to upload"}
        loading={!isFileUploaded}
        close={false}
        directordata={directorData}
        relatedType={"DIRECTOR"}
        categories={mergeCategories(["Entities +"], role)}
      />
      {attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={attachmentConfirmModal}
          closeModal={() => setAttachmentConfirmModal(false)}
          handleSave={handleConfirmDelete}
          isLoader={isAttachmentLoader}
        />
      )}
      <AttachmentSuccess
        successMsg={restoreMessage}
        setMessages={setRstoreMessage}
      />
      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Attachments"
          endpoint={API_ROUTES.FETCH_ATTACHMENT_AUDIT}
          id={directorId}
          objectType="DIRECTOR"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
    </div>
  );
};

export default DirectorProfileAttachments;
